//
// Copyright 2023 DXOS.org
//
import { reconstructError } from './helpers.js';
export const encodeError = (err) => {
    if (typeof err === 'object' && err?.message) {
        return {
            name: err.name,
            message: err.message,
            context: err.context,
            stack: err.stack,
        };
    }
    else if (typeof err === 'string') {
        return {
            message: err,
        };
    }
    else {
        return {
            message: JSON.stringify(err),
        };
    }
};
export const decodeError = (err, { appendStack } = {}) => {
    const error = reconstructError(err);
    if (appendStack) {
        error.stack = (err.stack ?? `${error.message}\n`) + appendStack;
    }
    else {
        error.stack = err.stack;
    }
    return error;
};
//# sourceMappingURL=encoding.js.map